import {BasketIconName} from './iconNames';

import assetIcEmptyBasket from './assets/ic-empty-basket.svg';
import assetSale from './assets/sale.svg';
export const basketIconAssets = {
  [BasketIconName.Empty]: assetIcEmptyBasket,
  [BasketIconName.Sale]: assetSale,
};
